import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';

import theme from './ColorSelector.scss';
import { selectWithButtonFactory } from 'common/components/core/select';
import { MlFontIcon } from 'common/components/core/font_icon/MlFontIcon';

class ColorMenuOption extends PureComponent {
    render() {
        const { selectProps, data, isSelected, innerProps } = this.props;
        const { theme } = selectProps;
        return (
            <span
                {...innerProps}
                className={classnames(theme.colorOptionWrap, {
                    [theme.isSelected]: isSelected
                })}
            >
                <MlFontIcon
                    key={data.name}
                    className={theme.colorMenuIcon}
                    color={data.name}
                    iconClass="circle"
                />
            </span>
        );
    }
}

const SelectWithButton = selectWithButtonFactory({
    Option: ColorMenuOption
});

class ColorSelector extends React.Component {
    onColorChange = option => this.props.onChange({ color: option.code });

    getOptionValue(option) {
        return option.code;
    }

    render() {
        const { color, colors, theme, helpText } = this.props;
        return (
            <SelectWithButton
                icon="fill-colour"
                ripple={false}
                buttonClassName={theme.colorBtn}
                theme={theme}
                isClearable={false}
                isSearchable={false}
                openMenuOnFocus
                options={colors ? colors : []}
                getOptionValue={this.getOptionValue}
                value={color?.code || color}
                onChange={this.onColorChange}
                className={classnames(theme.colorSelectorWrap, theme.dropdown)}
                menuHelpText={helpText}
            />
        );
    }
}

export default themr(null, theme)(ColorSelector);
